import React from 'react';

const Blog = () => {
    return (
        <div style={{ textAlign: 'center', margin: '20px auto' }}>
            <div>
                <h2 style={{marginTop:'20px'}}>1.Lunges</h2>
                <p style={{width:'50%',margin:'10px auto'}}>Challenging your balance is an essential part of a well-rounded exercise routine. Lunges do just that, promoting functional movement, while also increasing strength in your legs and glutes.</p>
                <video style={{width:'50%',height:'300px',border:'2px solid #a6c311'}} controls autoPlay loop src="video/1 (1).mp4"></video>
            </div>
            <div>
                <h2>1.Lunges</h2>
                <p style={{width:'50%',margin:'10px auto'}}>Challenging your balance is an essential part of a well-rounded exercise routine. Lunges do just that, promoting functional movement, while also increasing strength in your legs and glutes.</p>
                <video style={{width:'50%',height:'300px',border:'1px solid #a6c311'}} controls autoPlay loop src="video/1 (1).mp4"></video>
            </div>
            <div>
                <h2 style={{marginTop:'20px'}}>2.Pushups</h2>
                <p style={{width:'50%',margin:'10px auto'}}>Challenging your balance is an essential part of a well-rounded exercise routine. Lunges do just that, promoting functional movement, while also increasing strength in your legs and glutes.</p>
                <video style={{width:'50%',height:'300px',border:'2px solid #a6c311'}} controls autoPlay loop src="video/1 (2).mp4"></video>
            </div>
            <div>
                <h2 style={{marginTop:'20px'}}>3.Squats</h2>
                <p style={{width:'50%',margin:'10px auto'}}>Challenging your balance is an essential part of a well-rounded exercise routine. Lunges do just that, promoting functional movement, while also increasing strength in your legs and glutes.</p>
                <video style={{width:'50%',height:'300px',border:'2px solid #a6c311'}} controls autoPlay loop src="video/1 (3).mp4"></video>
            </div>
            <div>
                <h2 style={{marginTop:'20px'}}>4.Standing overhead dumbbell presses</h2>
                <p style={{width:'50%',margin:'10px auto'}}>Challenging your balance is an essential part of a well-rounded exercise routine. Lunges do just that, promoting functional movement, while also increasing strength in your legs and glutes.</p>
                <video style={{width:'50%',height:'300px',border:'2px solid #a6c311'}} controls autoPlay loop src="video/1 (4).mp4"></video>
            </div>
            <div>
                <h2 style={{marginTop:'20px'}}>5.Dumbbell rows</h2>
                <p style={{width:'50%',margin:'10px auto'}}>Challenging your balance is an essential part of a well-rounded exercise routine. Lunges do just that, promoting functional movement, while also increasing strength in your legs and glutes.</p>
                <video style={{width:'50%',height:'300px',border:'2px solid #a6c311'}} controls autoPlay loop src="video/1 (5).mp4"></video>
            </div>
        </div>
    );
};

export default Blog;